import { PlusCircleFilled } from '@ant-design/icons';
import { Tooltip } from 'antd';
import React from 'react';

const PlusIconActionButton = props => {
    return (
        <Tooltip title={props.title}>
            <div
                style={{
                    position: 'absolute',
                    bottom: '32px',
                    right: '52px',
                    cursor: 'pointer',
                    background: 'white',
                    padding: 0,
                    borderRadius: '50%',
                    zIndex: '3',
                    ...props.style,
                }}
                onClick={props.onClick}
            >
                <PlusCircleFilled
                    style={{
                        fontSize: '52px',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        color: '#673AB7',
                    }}
                />
            </div>
        </Tooltip>
    );
};

export default PlusIconActionButton;
